module.exports = __webpack_public_path__ + "assets/img/5225c88fa41b705143a04f0c7ed82e22.png";